import React, { useState, useEffect } from 'react';
import { formatearFechaInput, isoAFechaDisplay, fechaDisplayAIso } from '../services/fechas';

// Reemplazo del <input type="date"> nativo: tiene un bug de navegador que
// traba el año en 1900 al terminar de tipear el día/mes antes que el año
// (confirmado que no es cosa de React). Habla ISO (yyyy-mm-dd) hacia afuera
// — mismo contrato que un <input type="date"> normal — pero por dentro es
// texto con máscara (dd/mm/aaaa), así que no depende del control nativo.
const FechaDateInput = ({ value, onChange, name, className, placeholder, required, disabled, style, id }) => {
const [texto, setTexto] = useState(() => isoAFechaDisplay(value));

useEffect(() => {
setTexto(isoAFechaDisplay(value));
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [value]);

const handleChange = (e) => {
const nuevoTexto = formatearFechaInput(e.target.value);
setTexto(nuevoTexto);
if (nuevoTexto === '') {
onChange('');
return;
}
const iso = fechaDisplayAIso(nuevoTexto);
// Mientras la fecha está incompleta (menos de 8 dígitos) no se avisa al
// padre todavía: evita pisar el último valor válido mientras se sigue
// tipeando el año.
if (iso) onChange(iso);
};

return (
<input
type="text"
inputMode="numeric"
id={id}
name={name}
value={texto}
onChange={handleChange}
className={className}
placeholder={placeholder || 'dd/mm/aaaa'}
required={required}
disabled={disabled}
style={style}
/>
);
};

export default FechaDateInput;
